import { parse } from './duration';

// The different time units we support for prep time duration.
export const PREP_TIME_DURATION_SUPPORTED_UNITS = ['minutes'];
export const PREP_TIME_DURATION_TRANSLATION_KEYS = {
  minutes: {
    translation: 'common.duration.minutes'
  }
};
// Parses an ISO8601 duration string and returns an object describing
// the time unit (minutes, hours, days, etc) and the quantity.
export function parsePrepTimeDuration(prepTime) {
  const parsed = parse(prepTime);
  const keys = Object.keys(parsed);
  if (keys.length !== 1) {
    throw new Error(`Prep time duration value not supported: ${prepTime}`);
  }
  if (!PREP_TIME_DURATION_SUPPORTED_UNITS.includes(keys[0])) {
    throw new Error(`Prep time duration value not supported: ${prepTime}`);
  }
  return {
    timeUnit: keys[0],
    quantity: parsed[keys[0]]
  };
}